import React, { Component } from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';

import {Row, Col, Menu, Avatar, Dropdown, Icon, Modal, Tooltip, Select} from 'antd';
const { Option } = Select;
import { Link } from 'react-router-dom';

import UnreadNotifications from '../UnreadNotifications';
import NotificationsBadge from './NotificationsBadge';

import { api } from '../../../services';

import StatusIcon from '../../../common/icons/StatusIcon';
import CarIcon from '../../../common/icons/CarIcon';
import DashboardAnomalieIcon from '../../../common/icons/DashboardAnomalie';
import SupportagentIcon from '../../../common/icons/SupportIcons/SupportagentIcon';
import SupportView from './SupportView';

import logo from '../../../common/images/logoAir.png';

import K from '../../../constants';

import './Header.css';

import {observer, inject, disposeOnUnmount} from 'mobx-react';
import DealerSelector from "./DealerSelector";
import {reaction} from "mobx";

const VehicleHeaderItem = props => (
  <Row type="flex" onClick={props.onClick} className={`VehicleHeaderItem ${props.className}`} style={{ alignItems: 'center', ...props.style }}>
    <Col style={{ boxSizing: 'content-box', fontSize: '13px', color: 'black', fontWeight: '700', letterSpacing: '0.39px', padding: ' 10px', ...props.textStyle }}>{props.text}</Col>
    <div style={{ position: 'relative' }} className="iconContainer">
      {props.children}
      {!!props.icon && <div style={{ lineHeight: '0' }}>{props.icon}</div>}
      <div style={{ fontWeight: 'bold' }}>{props.value}</div>
    </div>
  </Row>
);

const preformattedSingleColumnText = (text) => {
  const splitted = text.split(" ");
  return `${splitted[0]}\n${splitted.slice(1).join(" ")}`;
  // return text.split(/^([^\s]+)\s(.+)/).join("\n");
};

@withRouter
@inject('translationsStore', 'communicationsStore', 'commonStore', 'authStore', 'commonStore')
@observer
class Header extends Component {
  constructor(props) {
    super(props);

    this.supportChannels = {
      phone: '0381092120',
      email: 'info@myair.io'
    };

    this.state = {
      dealer: { vehicleSummary: {}, leadsSummary: {} },
      supportModalVisible: false,
      supportKey: undefined
    };
  }

  componentDidMount() {
    disposeOnUnmount(this, reaction(
      () => this.props.commonStore.selectedDealers,
      async () => {
        await this.props.commonStore.loadDealersSummary();
        const status = this.props.location.search.split('?status=')[1];
        this.setState({ filter: status });
      },
      {
        fireImmediately: true
      }
    ));

  }

  static getDerivedStateFromProps(props, state) {
    return { ...state, filter: props.location.search.split('?status=')[1] };
  }

  handleSupportModalOk = () => {
    this.setState({
      supportModalVisible: false
    });
    setTimeout(() => {
      this.setState({
        supportKey: undefined
      });
    }, 500);
  };

  handleSupportModalCancel = () => {
    this.setState({
      supportModalVisible: false
    });
    setTimeout(() => {
      this.setState({
        supportKey: undefined
      });
    }, 500);
  };

  openSupportModal = () => {
    this.setState({
      supportModalVisible: true
    });
  };

  handleSupportSelectKey = supportKey => {
    this.setState({ supportKey });
  };

  toggleCommunicationsPopover = () => {
    const { communicationsStore } = this.props;
    communicationsStore.toggleVisiblePopover();
  };

  handleNotificationsModalOk = () => {
    this.toggleCommunicationsPopover();
  };

  handleNotificationsModalCancel = () => {
    this.toggleCommunicationsPopover();
  };

  openNotificationsModal = () => {
    this.toggleCommunicationsPopover();
  };

  render() {
    const { translationsStore, history, communicationsStore, authStore, commonStore } = this.props;
    const { dealersSummary } = commonStore;
    const { vehicleSummary = {}, leadsSummary = {} } = dealersSummary || {};

    const menu = (
      <Menu>
        <Menu.Item>
          <Link className="changepassword" to="/change-password">
            <Icon type="lock" />
            <span style={{ paddingLeft: '5px' }}>{translationsStore.translate('changepassword.link')}</span>
          </Link>
        </Menu.Item>
        <Menu.Item>
          <div
            onClick={() => {
              api('airweb token').then(result => {
                window.open(`${K.REGISTRATION_WEBAPP}/login?token=${result.refresh_token}&finalUrl=/registration`, 'registration');
              });
            }}
          >
            <Icon type="user-add" theme="outlined" />
            <span style={{ paddingLeft: '5px' }}>{translationsStore.translate('add_new_user')}</span>
          </div>
        </Menu.Item>
        {authStore.isAir &&
          <Menu.Item>
            <Link to="/fleet-managers">
              <Icon type="solution" />
              <span style={{ paddingLeft: '5px' }}>{translationsStore.translate('gotoFleetManagers')}</span>
            </Link>
          </Menu.Item>
        }
        <Menu.Item>
          <Link className="solution" to="/tickets">
            <Icon type="exception" />
            <span style={{ paddingLeft: '5px' }}>{translationsStore.translate('header.goToTickets')}</span>
          </Link>
        </Menu.Item>
        {commonStore.dealer && commonStore.dealer.serviceManagerEnabled && (
          <Menu.Item>
            <Link to="/service-managers">
              <Icon type="profile" />
              <span style={{ paddingLeft: '5px' }}>{translationsStore.translate('gotoServiceManagers')}</span>
            </Link>
          </Menu.Item>
        )}
        <Menu.Item>
          <Link className="logout" to="/logout">
            <Icon type="poweroff" />
            <span style={{ paddingLeft: '5px' }}>{translationsStore.translate('logout')}</span>
          </Link>
        </Menu.Item>
      </Menu>
    );
    return (
      <Row type="flex" className="Header" id="header">
        <Col className="header-item">
          <Link to="/dashboard" style={{ display: 'flex' }} className="header-item">
            <img src={logo} alt="" />
            <span style={{ fontSize: '20px', color: '#414042', fontWeight: '700', paddingLeft: 0 }}>MyDesk</span>
          </Link>
          <Tooltip title={translationsStore.translate('header.support.tooltip')}>
            <div className="supportIconWrapper" style={{ cursor: 'pointer' }} onClick={this.openSupportModal}>
              <SupportagentIcon />
            </div>
            <Modal
              className="supportModal"
              title={translationsStore.translate('header.support.modalTitle')}
              visible={this.state.supportModalVisible}
              bodyStyle={{ backgroundColor: 'white', padding: '0px' }}
              footer={null}
              onOk={this.handleSupportModalOk}
              onCancel={this.handleSupportModalCancel}
            >
              <SupportView channels={this.supportChannels} supportKey={this.state.supportKey} onSelectKey={this.handleSupportSelectKey} onOk={this.handleSupportModalOk} />
            </Modal>
          </Tooltip>

          <Modal
            title={translationsStore.translate('header.unreadNotifications.modalTitle')}
            visible={communicationsStore.visiblePopover}
            footer={null}
            onOk={this.handleNotificationsModalOk}
            onCancel={this.handleNotificationsModalCancel}
            width={760}
            className="UnreadNotificationsModal warning"
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <UnreadNotifications />
            </div>
          </Modal>
          <NotificationsBadge value={communicationsStore.unreadCount} onClick={this.openNotificationsModal} />

          {authStore.isAdmin &&
          <Switch>
              <DealerSelector/>
          </Switch>
          }
        </Col>

        <Col style={{ display: 'flex' }} className="header-item">
          <VehicleHeaderItem
            className={`dashboard ${!this.state.filter && this.props.location.pathname === '/dashboard' ? 'selected' : ''}`}
            text={preformattedSingleColumnText(translationsStore.translate('header.goToDashboard'))}
            value={leadsSummary.total}
            style={{ borderRight: '1px solid #707070', cursor: 'pointer' }}
            textStyle={{ whiteSpace: 'pre-line' }}
            icon={<DashboardAnomalieIcon style={{ fontSize: '24px' }} />}
            onClick={() => history.push('/dashboard')}
          />
          <VehicleHeaderItem
            className={`car ${!this.state.filter && this.props.location.pathname === '/carlist' ? 'selected' : ''}`}
            text={preformattedSingleColumnText(translationsStore.translate('header.totalVehicle'))}
            value={vehicleSummary.total}
            style={{ borderRight: '1px solid #707070', cursor: 'pointer' }}
            textStyle={{ whiteSpace: 'pre-line' }}
            icon={<CarIcon className="CarIcon" />}
            onClick={() => history.push('/carlist')}
          />
          <VehicleHeaderItem
            className={`disconnected ${this.state.filter === 'disconnected' ? 'selected' : ''}`}
            text={preformattedSingleColumnText(translationsStore.translate('header.disconnectedVehicle'))}
            value={vehicleSummary.disconnected}
            style={{ borderRight: '1px solid #707070', cursor: 'pointer' }}
            textStyle={{ whiteSpace: 'pre-line' }}
            icon={<StatusIcon className="StatusIcon" style={{ fontSize: '20px' }} />}
            onClick={() => history.push('/carlist?status=disconnected')}
          />
          <VehicleHeaderItem
            className={`shutdown ${this.state.filter === 'shutdown' ? 'selected' : ''}`}
            text={preformattedSingleColumnText(translationsStore.translate('header.vehicleWithShutdown'))}
            value={vehicleSummary.withShutdown}
            style={{ cursor: 'pointer' }}
            textStyle={{ whiteSpace: 'pre-line' }}
            icon={<StatusIcon className="StatusIcon" style={{ fontSize: '20px' }} />}
            onClick={() => history.push('/carlist?status=shutdown')}
          />

          <Dropdown overlay={menu} trigger={['click']}>
            <span style={{ height: '100%', lineHeight: '58px' }}>
              <Avatar icon="user" />
            </span>
          </Dropdown>
        </Col>
      </Row>
    );
  }
}

export default Header;
